export default {
  // Url cần thiết để render báo cáo
  PrintReport: 'print-report',
  CloseConnect: 'close-connect',
  DisplayReport: 'display-report',
  ReportLoadDone: "report-load-done"
}